import { ViewContainerRef, AfterViewInit, Component, ViewChild, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular/main';
import { Broadcast } from '../../../../core/events/broadcast';
import { AgRendererComponent } from "ag-grid-angular/dist/interfaces";
import { IAfterGuiAttachedParams } from "ag-grid/dist/lib/interfaces/iComponent";
import { IXSDropdownComponent } from "../../../dropdown/dropdown.component";
import { ICellRendererParams } from "ag-grid/dist/lib/rendering/cellRenderers/iCellRenderer";
import { MapConfiguration } from "../../../config";
import { RowNode } from "ag-grid/dist/lib/entities/rowNode";




@Component({
    selector: 'select-cell',
    template: `
<ixs-dropdown #select (change)="valueChange()" [(ngModel)]="value"></ixs-dropdown>`,
    styleUrls: ['selectStyle.css']
})

export class GridSelectComponent implements AgRendererComponent, AfterViewInit {
    ngAfterViewInit(): void {
        setTimeout(() => {
            this.dropdown.element.nativeElement.focus();
        });
    }

    @ViewChild('select') dropdown: any

    refresh(params: any): boolean {

        return true;
    }
    afterGuiAttached(params?: IAfterGuiAttachedParams): void {


    }
    private params: any;

    private column: any;

    public value: any;




    constructor() {

    }

    private async loadData() {

        this.dropdown.fieldName = this.column.colId + this.params.rowIndex;
        this.dropdown.showCaption = false;
        this.dropdown.valueMember = this.column.colDef.dataValueField;
        this.dropdown.displayMember = this.column.colDef.dataDisplayField;
        this.dropdown.caption = this.column.colDef.headerName;
        this.dropdown.config = this.column.colDef.config;
        this.dropdown.data = this.column.colDef.dropdownData;
        this.dropdown.disabled = !Boolean(this.params.colDef.editable === undefined ? true : this.params.colDef.editable);


    }


    async agInit(params: ICellRendererParams) {


        const element: HTMLElement = this.dropdown.element.nativeElement.children[0].children[0];
        if (element) {
            element.classList.add('grid-select-control');   
            element.style.width = "100%";

        }

        const span: HTMLElement = this.dropdown.element.nativeElement.children[0].children[1];
        if (span) {
            span.classList.add('grid-icon-control');
            span.classList.add('grid-input-search-icon');
        }
       
        this.params = params;
        this.value = this.params.value;
        this.column = this.params.column;
        await this.loadData();
        this.value = !this.value ? this.column.colDef.value : this.value
        params.node.setDataValue(this.column.colDef.field, !this.value ? this.column.colDef.value : this.value);
        this.mapFields();



        // this.params.api.startEditingCell({
        //     rowIndex: this.params.rowIndex,
        //     colKey: this.params.Column
        // });

        if (this.column && this.column.colDef && this.column.colDef.focus && this.column.colDef.focus === true) {
            await this.setSelectControlFocused();
        }
        const span1: HTMLElement = this.dropdown.element.nativeElement.children[0].children[1];
        if (span1) {
            span1.classList.remove('dropdown-radius');
        }
    }

    getValue(): any {

        return this.params.value;
    }

    valueChange() {

        this.params.setValue(this.value);
        this.mapFields();
    }

    mapFields() {
        if (this.params && this.params.node && this.column.colDef.mapFields && this.dropdown.data && this.value) {
            this.column.colDef.mapFields.forEach((element: MapConfiguration) => {
                const data = this.dropdown.data.filter(o => o[this.dropdown.valueMember] === this.value)[0];
                if (data) {
                    const val = data[element.mapField];
                    if (val) {
                        this.params.node.setDataValue(element.field, val);
                    }
                }

            });
        }
    }

    public async setSelectControlFocused() {
        if (this.dropdown && this.dropdown.element && this.dropdown.element.nativeElement && this.dropdown.element.nativeElement.children) {
            this.dropdown.element.nativeElement.children[0].children[0].focus();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/grid/editors/dropdown/gridselect.component.ts